<template>
	<div>
		<!-- <Slider
			animation="fade"
			v-model="sliderValue"
			:duration="5000"
			:speed="1000"
			style="height: 450px"
			>
			<SliderItem
				v-for="(item, index) in items"
				:key="index"
			>
				<div class="text-center">
					<img :src="item.media_url" style="height: 280px">
					<p>{{ item.title }}</p>
					<p>{{ item.sub_title }}</p>
					<p>
						<a :href="item.btn_value" target="_blank" class="btn btn-info">
							{{ item.btn_label }}
						</a>
					</p>
				</div>
			</SliderItem>
		</Slider>
		<hr/>
		<div class="row">
			<div class="col-md-3">
				<input class="form-control" v-model="new_item.media_url" placeholder="Media URL">
				<button class="btn btn-success" @click="addItem">Upload</button>
			</div>
			<div class="col-md-3">
				<input class="form-control" v-model="new_item.title" placeholder="Title">
			</div>
			<div class="col-md-3">
				<input class="form-control" v-model="new_item.sub_title" placeholder="Sub-title">
			</div>
			<div class="col-md-3">
				<input class="form-control" v-model="new_item.btn_label" placeholder="Button label">
				<input class="form-control" v-model="new_item.btn_value" placeholder="Button Value">
			</div>
		</div> -->
		<!-- START RESPONSE TYPE STATIC CARDS -->
		<table
			class="table table-bordered table-striped table-sm"
			v-if="static_cards && static_cards.length"
		>
			<thead>
				<tr>
					<th>{{ $t('Title') }}</th>
					<th>{{ $t('Sub title') }}</th>
					<th>{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(card, ic) in static_cards"
					:key="`response-static-card-${ic}`"
				>
					<td v-html="card.title_key || card.title_default_value "></td>
					<td v-html="card.subtitle_key || card.subtitle_default_value "></td>
					<td class="text-center">
						<button type="button" class="btn btn-link p-0 mr-2">
							<i @click="static_card_emit('edit', ic)" class="fa fa-edit fa-lg" :title="$t('edit')"></i>
						</button>
						<button type="button" class="btn btn-link p-0 mr-2">
							<i
								@click="static_card_emit('delete', ic)"
								class="fa fa-remove fa-lg"
								:title="$t('delete')"
							></i>
						</button>
					</td>
				</tr>
				<tr v-if="!resp_static_cards_resp_struct.length">
					<td colspan="4">
						<div class="text-center">{{ $t('no data') }}</div>
					</td>
				</tr>
			</tbody>
		</table>

		<b-alert variant="danger" dismissible :show="!!error_resp_static_cards_resp_struct">
			<button
				type="button"
				aria-label="Close"
				class="close"
				@click="error_resp_static_cards_resp_struct = false"
			>x</button>
			<div v-html="error_resp_static_cards_resp_struct"></div>
		</b-alert>

		<ComamandResponseCard
			:buttons="resp_static_cards_resp_struct.buttons"
			:btnLabel="resp_static_cards_resp_struct.item_label_key || resp_static_cards_resp_struct.item_label_default_value"
			:title="resp_static_cards_resp_struct.title_key || resp_static_cards_resp_struct.title_default_value"
			:subTitle="resp_static_cards_resp_struct.subtitle_key || resp_static_cards_resp_struct.subtitle_default_value"
			:autoCompleteModules="autocomplete"
			:checkMediaBackground="true"
			:media="resp_static_cards_resp_struct.media_key || resp_static_cards_resp_struct.media_default_value"
			@onNewButtonClick="push_button(resp_static_cards_resp_struct.buttons)"
			@onRemoveButtonClick="(pos) => remove_button(pos, resp_static_cards_resp_struct.buttons)"
		>
			<template slot="title">
				<tooltip label="value" placement="right">
					<input
						name="title_key"
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="resp_static_cards_resp_struct.title_key"
						:placeholder="$t('value')"
					/>
				</tooltip>
				<tooltip label="default value" placement="right">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="resp_static_cards_resp_struct.title_default_value"
						:placeholder="$t('default value')"
					/>
				</tooltip>
			</template>

			<template slot="subTitle">
				<tooltip label="value" placement="right">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="resp_static_cards_resp_struct.subtitle_key"
						:placeholder="$t('value')"
					/>
				</tooltip>
				<tooltip label="default value" placement="right">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="resp_static_cards_resp_struct.subtitle_default_value"
						:placeholder="$t('default value')"
					/>
				</tooltip>
			</template>

			<template slot="media">
				<tooltip label="value" placement="right">
					<image-uploader
						:imageType="'file'"
						:imagePreview="false"
						@imageSelected="image => resp_static_cards_resp_struct.media_key = image.dataURI"
						@linkChanged="link => resp_static_cards_resp_struct.media_key = link"
					></image-uploader>
				</tooltip>
				<!-- <tooltip label="default value" placement="right">
							<input
								class="form-control"
								v-autocomplete="autocomplete"
								v-model="resp_static_cards_resp_struct.media_default_value"
								:placeholder="$t('default value')"
							/>
				</tooltip>-->
			</template>

			<template
				:slot="'button.' + ii"
				v-for="(button, ii) in  resp_static_cards_resp_struct.buttons"
			>
				<tooltip label="button label" placement="right" :key="'button.label.' + ii">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="button.item_label_key"
						:placeholder="$t('button label')"
					/>
				</tooltip>

				<tooltip label="button value" placement="right" :key="'button.value.' + ii">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="button.item_value_key"
						:placeholder="$t('button value')"
					/>
				</tooltip>
			</template>
		</ComamandResponseCard>

		<div class="form-group form-actions mt-0 mb-0">
			<button
				:disabled="resp_static_cards_resp_struct.length >= 5"
				type="button"
				v-show="mode_resp_static_cards_resp_struct == 'add'"
				@click="static_card_emit('add')"
				class="btn btn-primary btn-sm btn-square mb-0"
			>{{ $t('Add Card') }}</button>
			<button
				type="button"
				v-show="mode_resp_static_cards_resp_struct == 'edit'"
				@click="static_card_emit('update')"
				class="btn btn-success btn-sm btn-square active mb-0"
			>{{ $t('Edit Card') }}</button>
		</div>
	<!-- END RESPONSE TYPE STATIC CARDS -->
	</div>
</template>

<script>
	// import { Slider, SliderItem } from "vue-easy-slider";
	import ComamandResponseCard from '../../../components/ComamandResponseCard'

	export default {
		components: {
			ComamandResponseCard
		},
		methods: {
			// addItem() {
			// 	this.items.push(this.new_item)

			// 	this.new_item = {
			// 		media_url: null,
			// 		title: null,
			// 		sub_title: null,
			// 		btn_label: null,
			// 		btn_value: null,
			// 	}
			// },
			static_card_emit(mode, pos) {
				var card = this.resp_static_cards_resp_struct
				var empty_card = {
					title_key: '',
					title_default_value: '',
					subtitle_key: '',
					subtitle_default_value: '',
					media_key: '',
					media_default_value: '',
					buttons: [
						{
							item_label_key: '',
							item_label_default_value: '',
							item_value_key: '',
							item_value_default_value: '',
						},
					],
				}
				// check if a valid card
				if (
					mode !== 'edit' &&
					mode !== 'delete' &&
					((!card.media_key.length && !card.media_default_value.length) ||
						(!card.title_key.length && !card.title_default_value.length))
				) {
					this.error_resp_static_cards_resp_struct = 'please complete required fields like media & title!'
					return false
				} else {
					this.error_resp_static_cards_resp_struct = false
				}

				switch (mode) {
					case 'add':
						if (this.static_cards.length < 5) {
							this.static_cards.push(card)
							this.resp_static_cards_resp_struct = {
								...empty_card,
							}
						}
						break
					case 'edit':
						this.resp_static_cards_resp_struct = {
							pos: pos,
							...this.static_cards[pos],
						}
						this.mode_resp_static_cards_resp_struct = 'edit'
						break
					case 'update':
						if (is_num(card.pos)) {
							pos = card.pos
							delete card['pos']
							this.static_cards[pos] = {...card}
							this.resp_static_cards_resp_struct = {
								...empty_card,
							}
							this.mode_resp_static_cards_resp_struct = 'add'
						}
						break
					case 'delete':
						if (is_num(pos)) {
							this.static_cards.splice(pos, 1)
						}
						break
				}
				
				this.$store.commit('setResponseDataProperty', {resp_static_cards_resp_struct: this.static_cards})
			},
			push_button(btns_arr) {
				btns_arr.push({
					item_label_key: '',
					item_label_default_value: '',
					item_value_key: '',
					item_value_default_value: '',
				})
			},
			remove_button(pos, btns_arr) {
				btns_arr.splice(pos, 1)
			},
		},
		data() {
			return {
				sliderValue: 2,
				resp_static_cards_resp_struct: {
					title_key: '',
					title_default_value: '',
					subtitle_key: '',
					subtitle_default_value: '',
					media_key: '',
					media_default_value: '',
					buttons: [
						{
							item_label_key: '',
							item_label_default_value: '',
							item_value_key: '',
							item_value_default_value: '',
						},
					],
				},
				error_resp_static_cards_resp_struct: false,
				static_cards: [],
				items: [
					{
						media_url: 'https://www.prestigeanimalhospital.com/sites/default/files/styles/large/adaptive-image/public/golden-retriever-dog-breed-info.jpg',
						title: 'dog',
						sub_title: 'golden retriever',
						btn_label: 'DOG',
						btn_value: 'https://www.prestigeanimalhospital.com/sites/default/files/styles/large/adaptive-image/public/golden-retriever-dog-breed-info.jpg',
					},
					{
						media_url: 'https://dynaimage.cdn.cnn.com/cnn/c_fill,g_auto,w_1200,h_675,ar_16:9/https%3A%2F%2Fcdn.cnn.com%2Fcnnnext%2Fdam%2Fassets%2F190517103414-01-grumpy-cat-file-restricted.jpg',
						title: 'cat',
						sub_title: 'grumpy cat',
						btn_label: 'CAT',
						btn_value: 'https://dynaimage.cdn.cnn.com/cnn/c_fill,g_auto,w_1200,h_675,ar_16:9/https%3A%2F%2Fcdn.cnn.com%2Fcnnnext%2Fdam%2Fassets%2F190517103414-01-grumpy-cat-file-restricted.jpg',
					}
				],
				new_item: {
					media_url: null,
					title: null,
					sub_title: null,
					btn_label: null,
					btn_value: null,
				},
				autocomplete: {},
				mode_resp_static_cards_resp_struct: 'add',
			}
		},
		created() {
			this.autocomplete = Object.assign(this.autocomplete, clone(this.$store.state.autocomplete))
		},
	}
</script>

<style lang="scss" scoped>
</style>
